<template>
  <div class="Header is-absolute  w" :class="fixedTop?'is-absolute-show':''">
    <div class="cus-bar">
      <section class="container">
        <div class="logo"><img :src="logoUrl" style="height:48px;"/></div>
      </section>
      <div class="aside-cont">
        <div class="nav-box">
          <div class="nav">
            <li v-for="(item, index) in narArr" :key="index" :class="{active:index === currentIndex,fixed:fixedTop}"  @click="routerLink(index, item.path)">{{item.title}}</li>
          </div>
      </div>
      </div>
    </div>
  </div>
</template>

<script>
import logo_w from '../assets/images/logo_w.png'
import logo from '../assets/images/logo.png'
export default {
  name: 'Header',
  data () {
    return {
      msg: 'Welcome to Grantbio Biotech',
      logoUrl:logo,
      currentIndex: 0,
      fixedTop:false,
      absolute:true,
      narArr: [
        {
          path: '/',
          title: '首页'
        },
        {
          path: '/service',
          title: '论文服务'
        },
        {
          path: '/tech',
          title: '技术服务'
        },
        {
          path: '/other',
          title: '其它服务'
        },
        {
          path: '/guide',
          title: '服务指南'
        },
        {
          path: '/contact',
          title: '关于我们'
        }
      ]
    }
  },
  mounted(){
    if (this.absolute) {
      this.handleScroll();
      window.addEventListener('scroll', this.handleScroll, false);
    }
  },
  beforeDestroy(){
    if (this.absolute) {
      window.removeEventListener('scroll', this.handleScroll, false);
    }
  },
  watch:{
    $route:{
      handler(val,oldVal){
        this.narArr.forEach((item,index)=>{
          if(val.path.indexOf(item.path)>=0){
            this.currentIndex = index
          }
        })
      }
    }
  },
  methods: {
    routerLink (index, path) {
      this.currentIndex = index
      this.$router.push(this.narArr[index])
    },
    handleScroll() {
        const _top = window.pageYOffset;
        this.fixedTop = _top > 45 ? true : false;
        if(this.fixedTop){
          this.logoUrl = logo
        }else{
          this.logoUrl = logo_w
        }
    }
  }
}
</script>

<style lang="scss" scoped>
  .is-absolute-show{
    position: fixed !important;
    width: 100%;
    background: #fff;
    left: 0;
    top: 0;
    box-shadow: 0 3px 16px #e2e2e2;
  }
  .w{
    margin-bottom: -72px;
  }
  .Header{
    position: relative;
    z-index: 100;
    font-size: 14px;
    width: 100%;
    left: 0;
    top: 0;
    overflow: hidden;
    .is-absolute{
      z-index: 201;
      transition: opacity .4s,transform .4s;
    }
    .cus-bar{
        transform: translateZ(0);
        color: #fff;
        padding-top: 12px;
        padding-bottom: 12px;
    }
    .container{
      width: 1440px;
      margin-left: auto;
      margin-right: auto;
    }
    .logo{
      position: relative;
      float: left;
      z-index: 12;
      .title{
        color:#fff;
        margin-left:8px;
        vertical-align: middle;
        bottom: 20px;
        font-size: 24px;
        position: relative;
        font-family: "arial black", "avant garde", 微软雅黑;
      }
      .fixed{
        color:#595959;
      }
    }
    .aside-cont{
      float: right;
      z-index: 11;
      height: 56px;
    .nav-box{
      line-height: 38px;
      margin-left: 60px;
      float: left;
      .nav{
        margin: 6px auto;
        width: 1100px;
        font-size: 0;
        li {
          display: inline-block;
          width: 120px;
          text-align: center;
          font-size: 16px;
          line-height: 32px;
          vertical-align: middle;
          position: relative;
          color: #fff;
          cursor: pointer;
          &:hover{
            color: #409EFF;
          }
        }
        li.fixed{
          color: #595959;
        }
        li.active{
          &::after{
            content: "";
            bottom:-15px;
            left:25px;
            right:25px;
            border-bottom: 4px solid #0e59f0;
            position: absolute;
          }

        }
        &::after{
          content: '';
          display: inline-block;
          vertical-align: middle;
          height: 35px;
        }
      }
    }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Header.vue